import React, { useState, useRef, useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';
import './recommended-badge.scss';

const RecommendedBadge: React.FC<{ reason?: string }> = ({ reason }) => {
  const [hovered, setHovered] = useState(false);
  const badgeRef = useRef<HTMLSpanElement>(null);
  const [tooltipPos, setTooltipPos] = useState<{ top: number; left: number }>({
    top: 0,
    left: 0,
  });

  const updatePosition = useCallback(() => {
    if (badgeRef.current) {
      const rect = badgeRef.current.getBoundingClientRect();
      setTooltipPos({
        top: rect.bottom + 8,
        left: rect.left,
      });
    }
  }, []);

  useEffect(() => {
    if (hovered && reason) {
      updatePosition();
    }
  }, [hovered, reason, updatePosition]);

  return (
    <span
      ref={badgeRef}
      className='recommended-badge'
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      Recommended
      {hovered &&
        reason &&
        createPortal(
          <span
            className='recommended-badge-tooltip'
            style={{ top: tooltipPos.top, left: tooltipPos.left }}
          >
            {reason}
          </span>,
          document.body,
        )}
    </span>
  );
};

export default RecommendedBadge;
